import React from 'react';
import { Utensils } from 'lucide-react';
import type { MealEntry } from '../types/mealMonitor';

interface MealEntryCardProps {
  entry: MealEntry;
  isHighestCalorie?: boolean;
}

const MealEntryCard: React.FC<MealEntryCardProps> = ({ entry, isHighestCalorie = false }) => {
  const formatTime = (dateString?: string) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className={`rounded-lg border p-3 hover:shadow-sm transition-shadow ${
      isHighestCalorie
        ? 'bg-red-50 border-red-200'
        : 'bg-white border-gray-200'
    }`}>
      <div className="flex items-center gap-3">
        <div className="flex-shrink-0">
          <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
            <Utensils className="h-4 w-4 text-blue-600" />
          </div>
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between gap-2">
            <h4 className="text-sm font-medium text-gray-900 truncate">
              {entry.food_name}
            </h4>
            {entry.entry_date && (
              <span className="text-xs text-gray-400 flex-shrink-0">
                {formatTime(entry.entry_date)}
              </span>
            )}
          </div>

          <div className="mt-1 flex flex-wrap gap-x-3 gap-y-0.5 text-xs text-gray-600">
            <span className="text-gray-500">{entry.weight}г</span>
            {entry.calories !== undefined && entry.calories > 0 && (
              <span className="text-blue-600 font-medium">
                {entry.calories.toFixed(0)} ккал
              </span>
            )}
            {entry.protein !== undefined && entry.protein > 0 && (
              <span>Б: <span className="font-medium">{entry.protein.toFixed(1)}</span></span>
            )}
            {entry.fat !== undefined && entry.fat > 0 && (
              <span>Ж: <span className="font-medium">{entry.fat.toFixed(1)}</span></span>
            )}
            {entry.carbs !== undefined && entry.carbs > 0 && (
              <span>У: <span className="font-medium">{entry.carbs.toFixed(1)}</span></span>
            )}
            {entry.fiber !== undefined && entry.fiber > 0 && (
              <span>Кл: <span className="font-medium">{entry.fiber.toFixed(1)}</span></span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MealEntryCard;
